import { Input, message } from "antd";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Router from "../";
import logo from "../../../src/images/SurfingCre2.png";
import logoMobile from "../../../src/images/SurfingCre1.png";
import { validateField, validators } from "../utils/Regex";

export const ResetPassword = () => {
  const history = useHistory();
  const location = useLocation();
  const [passwordFields, setPasswordFields] = useState({
    password: "",
    passwordCheck: "",
  });
  const [validationStatus, setValidationStatus] = useState({
    password: { isValid: false, message: "" },
    passwordCheck: { isValid: false, message: "" },
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordFields((prev) => ({ ...prev, [name]: value }));

    if (name === "password") {
      const validation = validateField("password", value);
      setValidationStatus((prev) => ({ ...prev, password: validation }));

      if (passwordFields.passwordCheck) {
        const passwordCheckValidation = validateField(
          "passwordCheck",
          passwordFields.passwordCheck,
          {
            password: value,
          }
        );
        setValidationStatus((prev) => ({
          ...prev,
          passwordCheck: passwordCheckValidation,
        }));
      }
    } else if (name === "passwordCheck") {
      const validation = validateField("passwordCheck", value, {
        password: passwordFields.password,
      });
      setValidationStatus((prev) => ({ ...prev, passwordCheck: validation }));
    }
  };

  // 폼 제출 핸들러
  const handleSubmit = async (e) => {
    e.preventDefault();

    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      message.error("유효하지 않은 링크입니다.");
      return;
    }
    if (!validators.password(passwordFields.password)) {
      message.error("올바른 비밀번호 형식을 입력해주세요.");
      return;
    }
    if (passwordFields.password !== passwordFields.passwordCheck) {
      message.error("비밀번호가 일치하지 않습니다.");
      return;
    }

    setIsSubmitting(true);
    const success = await Router.Api.confirmResetPassword({
      token,
      new_password: passwordFields.password,
    });

    if (success) {
      setTimeout(() => history.push("/signin"), 2000);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="auth">
      <div className="login_box w-full md:w-[45%] md:shadow-[8px_0px_8px_0_rgba(50,42,42,0.7)]">
        <img
          src={logoMobile}
          className="block md:hidden mb-12 mx-auto w-1/2"
          alt="로고"
        />
        <img src={logo} className="logo hidden md:block" alt="로고" />
        <h1>비밀번호 재설정</h1>
        <form onSubmit={handleSubmit} className="signup_form w-full md:w-[50%]">
          <p>새 비밀번호</p>
          <Input
            size="large"
            type="password"
            name="password"
            value={passwordFields.password}
            onChange={handlePasswordChange}
            placeholder="비밀번호를 입력하세요"
            autoComplete="new-password"
            required
            disabled={isSubmitting}
          />
          <div className="text-xl text-[#666] mt-1">
            최소 8자 이상, 대/소문자, 숫자, 특수문자(@$!%*?&)를 포함해야 합니다
          </div>
          {validationStatus.password.message && (
            <div
              className={`text-xl mt-1 ${
                validationStatus.password.isValid
                  ? "text-[#52c41a]"
                  : "text-[#ff4d4f]"
              }`}
            >
              {validationStatus.password.message}
            </div>
          )}

          <p>비밀번호 확인</p>
          <Input
            size="large"
            type="password"
            name="passwordCheck"
            value={passwordFields.passwordCheck}
            onChange={handlePasswordChange}
            placeholder="비밀번호를 다시 입력하세요"
            autoComplete="new-password"
            required
            disabled={isSubmitting}
          />
          {validationStatus.passwordCheck.message && (
            <div
              className={`text-xl mt-1 ${
                validationStatus.passwordCheck.isValid
                  ? "text-[#52c41a]"
                  : "text-[#ff4d4f]"
              }`}
            >
              {validationStatus.passwordCheck.message}
            </div>
          )}

          <button
            type="submit"
            className={`btn ${isSubmitting ? "opacity-60" : "opacity-100"}`}
            disabled={isSubmitting}
          >
            비밀번호 재설정하기
          </button>
        </form>
      </div>
      <div className="intro hidden md:block md:w-[55%]"></div>
    </div>
  );
};
